import { FieldProps } from "rc-field-form/es/Field";
import React, { useState } from "react";
import { Meta } from "rc-field-form/es/interface";
import Form from "rc-field-form";
import style from "./index.module.scss";
import classNames from "classnames";
import { Col, Icon, Row, Tooltip } from "antd";
import className from "classnames";

interface FieldWithErrorProps extends FieldProps {
    errorClassName?: string;
    label: string;
    require?: boolean;
    align?: "top" | "middle" | "bottom";
    span?: number[];
    help?: string;
}

export default function FieldWithErrorHaveLabel({
    errorClassName,
    require = false,
    span = [5, 17],
    align = "top",
    label,
    help,
    ...props
}: FieldWithErrorProps) {
    const [meta, setMeta] = useState<Meta>();

    return (
        <React.Fragment>
            <Row
                gutter={15}
                align={align}
                type="flex"
                style={{ marginBottom: 15 }}>
                <Col sm={span[0]} xs={24}>
                    <div
                        className={className(
                            require && "required_overflow",
                            "label32",
                            style.label
                        )}>
                        {label}
                        {help && (
                            <Tooltip
                                className={style.help}
                                placement="topLeft"
                                title={help}>
                                <Icon type="question-circle" />
                            </Tooltip>
                        )}
                    </div>
                </Col>
                <Col sm={span[1]} xs={24}>
                    <Form.Field {...props} onMetaChange={setMeta}>
                        {props.children}
                    </Form.Field>
                    <div className={classNames(style.error, errorClassName)}>
                        {meta?.errors[0]}
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
}
